<!-- 我的合同 -->
<template>
  <div class="myContract_box">
    <div v-for="(item,index) in contractList" :key="index" style="display:inline-block;">
      <div class="contract_item" v-if="item.signingStatus == 0">
        <div class="contract_item_name">{{item.contractName}}<span class="status">{{item.signingStatus | statusFormat}}</span></div>
        <div class="contract_item_img">
          <img src="@/assets/toBeSigned.png" class="img" />
          <span class="btn" @click="showContract(item)">签署合同<i class="el-icon-arrow-right"></i></span>
        </div>
      </div>
      <div class="contract_item signed" v-if="item.signingStatus == 1">
        <div class="contract_item_name signed_name">{{item.contractName}}<span class="status">{{item.signingStatus | statusFormat}}</span></div>
        <div class="date">签署日期：<span>{{ getDate(item.siginingDate)}}</span></div>
        <div class="contract_item_img signed_img">
          <img src="@/assets/signed.png" class="img" />
          <span class="btn signed_btn" @click="showContract(item,1)">查看</span>
        </div>
      </div>
      <div class="contract_item signed suspension" v-if="item.signingStatus == 2">
        <div class="contract_item_name suspension_name">{{item.contractName}}<span class="status">{{item.signingStatus | statusFormat}}</span></div>
        <div class="date">签署日期：<span>{{getDate(item.siginingDate) }}</span></div>
        <div class="contract_item_img signed_img">
          <img src="@/assets/signed.png" class="img" />
          <span class="btn suspension_btn" @click="showContract(item,1)">查看</span>
        </div>
      </div>
    </div>
    <contract-msg ref="contractContent" :pageType="pageType" :contractRow="contractRow" :openType="openType" @querySaasContractList="querySaasContractList"></contract-msg>
  </div>
</template>
<script>
import contractMsg from './contractMsg.vue';
import fetchPost from "@/api/http.js";
import { formatDate } from "@/common/js/date.js";
export default {
  components: { contractMsg },
  data() {
    return {
      contractList: [],
      contractRow: {},
      openType: "",
      pageType:1,//1.合同列表 2.发临时单
    }
  },
  mounted() {
    this.querySaasContractList();
  },
  filters: {
    statusFormat(statu) {
      switch (statu) {
        case '0':
        case 0:
          return '待签署';
          break;
        case '1':
        case 1:
          return '已签署';
          break;
        case '2':
        case 2:
          return '终止';
          break;
        default:
          return statu;
          break;
      }
    }
  },
  methods: {
    getDate(val) {
      if (val) {
        var date = new Date(val);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (month < 10) month = "0" + month;
        var day = date.getDate();
        if (day < 10) day = "0" + day;
        return year + "年" + month + "月" + day + "日";
      }
    },
    showContract(item, type) {
      if (type == 1) {
        this.openType = 1;
      } else {
        this.openType = "";
      }
      this.contractRow = item;
      if(item.contractGenerationId){
        this.$message({
          type: "error",
          message: '请去小程序端操作！'
        });
        return
      } else {
        this.$refs.contractContent.queryContractInfo(item.id);
      }
      
    },
    querySaasContractList() {
      fetchPost("/saas/contract/querySaasContractList", {}).then(res => {
        //console.log(res, 123)
        this.contractList = res;
      });
    }

  }
}
</script>
<style scoped>
.myContract_box {
  padding: 24px !important;
}
.contract_item {
  display: inline-block;
  width: 350px;
  height: 146px;
  margin: 0 32px 32px 0 !important;
  background: #d95757;
  border-radius: 4px;
  position: relative;
}
.contract_item_name {
  height: 25px;
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: -0.25px;
  font-weight: 500;
  padding: 24px !important;
}
.status {
  float: right;
  font-size: 16px;
}
.img {
  width: 93.14px;
  height: 56.9px;
}
.contract_item_img {
  padding: 40px 24px 0 24px !important;
}
.btn {
  position: static;
  height: 57px;
  line-height: 57px;
  float: right;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: -0.22px;
  text-align: right;
  font-weight: 400;
}
.date {
  padding: 6px 0 0 24px !important;
  height: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: -0.19px;
  font-weight: 400;
}
.signed {
  background: #f6f6f6;
}
.signed_img {
  padding: 20px 24px 0 24px !important;
}
.signed_name {
  color: #000000;
}
.signed_btn {
  color: #dc1e32;
}
.suspension {
  color: #666666;
}
.suspension_btn {
  color: #7a7a7a;
}
.suspension_name {
  color: #666666;
}
</style>